/**
 * 访问账户充值记录列表页面的权限
 */
export const RECHARGE_APPLY_LIST_PAGE_UUID =
  '7f4e75e2-b94a-440d-9b58-40c4ac270da7'

/**
 * 访问创建账户充值申请页面的权限
 */
export const RECHARGE_APPLY_CREATE_PAGE_UUID =
  '8ef7775c-95eb-491d-b975-63bda52206f5'

/**
 * 审批账户充值申请的权限
 */
export const RECHARGE_APPLY_AUDIT_ACTION_UUID =
  '8bf3817d-23fd-4c54-8300-e13c614e537e'
